/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import {
  Box,
  Checkbox,
  Container,
  FormControlLabel,
  Stack,
  Typography,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { getFormProps, getSubmitButtonProps } from '@marageti/z4-lib';
import { useForm } from 'react-hook-form';
import { z } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';

const schema = z.object({
  acceptTerms: z.boolean().refine((val) => val === true),
});

const NewsletterSignupView = ({
  onSubmit,
}: {
  onSubmit: () => {},
}) => {
  const {
    register,
    handleSubmit,
    formState: { isSubmitting, isValid },
  } = useForm({
    resolver: zodResolver(schema),
    mode: 'onChange',
  });

  return (
    <Box
      sx={{
        mt: 3,
        backgroundColor: '#F0F0F0',
      }}
    >
      <Container maxWidth="xl">
        <Stack
          spacing={{
            desktop: 0,
            mobile: 2,
          }}
          paddingY={4}
          direction={{ desktop: 'row', mobile: 'column' }}
          justifyContent={{ desktop: 'space-between', mobile: 'center' }}
          alignItems={{ desktop: 'center', mobile: 'flex-start' }}
        >
          <Stack
            spacing={0.5}
            direction="column"
            justifyContent="space-between"
          >
            <Typography fontWeight="bold">
              Inspiration and expert advice in your inbox each week
            </Typography>
            <Typography>
              Subscribe to our newsletter for travel trends, news, and helpful tips
            </Typography>
          </Stack>
          <form {...getFormProps(handleSubmit(onSubmit))}>
            <Stack
              spacing={{
                desktop: 2,
                mobile: 1.5,
              }}
              direction={{ desktop: 'row', mobile: 'column' }}
              justifyContent="space-betwee"
              alignItems="flex-start"
            >
              <FormControlLabel
                control={(
                  <Checkbox
                    {...register('acceptTerms')}
                    color="primary"
                  />
              )}
                label="I agree to receive marketing emails from Zicasso"
                style={{ marginLeft: '-11px' }}
              />
              <LoadingButton
                variant="contained"
                type="submit"
                sx={{ width: '116px', height: '44px' }}
                {...getSubmitButtonProps(isSubmitting, isValid)}
              >
                Subscribe
              </LoadingButton>
            </Stack>
          </form>
        </Stack>
      </Container>
    </Box>
  );
};

export default NewsletterSignupView;
